<input
  type="file"
  #fileInput
  (change)="onFileSelected($event)"
  style="display: none;"
>

<i (click)="fileInput.click()" class="material-symbols-outlined">upload</i>

@if (control().value) {
  <i (click)="downloadFile()" class="material-symbols-outlined">download</i>
  <i (click)="removeFile(fileInput)" class="material-symbols-outlined">delete</i>
}
<span class="file-name">{{fileName || control().value || label() }}</span>
